import React, { ChangeEvent, useId } from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classNames from 'classnames/bind';

import styles from './BasicTextarea.module.scss';

const cx: CX = classNames.bind(styles);

function BasicTextarea(props: Props) {
    const {
        title, placeholder, value, onChange,
    } = props;

    const inputId = useId();

    function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
        onChange(event.target.value);
    }

    return (
        <div className={cx('basic-textarea')}>
            <label htmlFor={inputId}>
                <div className={cx('title')}>
                    {title}
                </div>
            </label>
            <textarea
                id={inputId}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
            />
        </div>
    );
}

BasicTextarea.defaultProps = {
    placeholder: '',
};

BasicTextarea.propTypes = {
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

type Props = InferProps<typeof BasicTextarea.propTypes> & typeof BasicTextarea.defaultProps;

export default BasicTextarea;
